import { buildOrgPath, PATHS } from "@constants/Paths";
import { useOptionalActiveOrganization } from "@stores/ActiveOrganizationContext";
import { useAuthContext } from "@stores/AuthContext";
import { getIsAdmin } from "@stores/utils";
/**
 * Where "back to home" goes for whoever is looking. There is no single home path: staff are not
 * org-scoped and belong on the admin dashboard, a member's home lives under their `/o/:orgId`, and
 * the unprefixed `/home` renders Restricted by design — so navigating to `PATHS.HOME` directly is
 * always wrong for someone.
 */
export const useHomeDestination = () => {
    const { user } = useAuthContext();
    const activeOrgContext = useOptionalActiveOrganization();
    if (getIsAdmin(user))
        return PATHS.ADMIN_DASHBOARD;
    return activeOrgContext ? buildOrgPath(activeOrgContext.activeOrgId, PATHS.HOME) : PATHS.RESTRICTED;
};
